import React, { ReactNode, FC } from 'react';
import { Card, CardVariant } from '@/features/card/Card';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

type Props = {
  currentLabel: React.ReactNode;
  currentValue: React.ReactNode;
  previousLabel?: React.ReactNode;
  previousValue?: React.ReactNode;
  icon: ReactNode;
  classNames?: string;
  boxShadowColor?: string;
  hasTooltip?: boolean;
  toolTipClicked?: () => void;
  /**
   * Card variant: 'elevated' (default), 'outlined', or 'flat'
   * @default 'elevated'
   */
  variant?: CardVariant;
};

export const CardStats: FC<Props> = ({
  currentLabel,
  currentValue,
  previousLabel,
  previousValue,
  icon,
  classNames = '',
  boxShadowColor,
  hasTooltip = false,
  toolTipClicked,
  variant = 'elevated',
}) => (
  <Card
    className={classNames}
    boxShadowColor={boxShadowColor}
    variant={variant}
  >
    <div className="w-full h-full flex flex-col items-center justify-between relative gap-2">
      <div className="flex flex-row items-center justify-between relative w-full">
        <div>
          <div className="text-sm text-gray-500">{currentLabel}</div>
          <div>{currentValue}</div>
        </div>
        {icon}
      </div>
      {previousLabel &&
        previousValue !== undefined &&
        previousValue !== null && (
          <div className="flex flex-col relative w-full">
            <div className="text-sm text-gray-500">{previousLabel}</div>
            <div className="text-sm ">{previousValue}</div>
          </div>
        )}

      {hasTooltip && (
        <div className="absolute bottom-[-5px] right-1">
          <IconButton onClick={toolTipClicked}>
            <InfoIcon sx={{ fontSize: '14px' }} />
          </IconButton>
        </div>
      )}
    </div>
  </Card>
);
